import { useState, useEffect } from "react";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { Card, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { decryptFromStoreLoc } from "../../helper/localStore";
import { toast } from "react-toastify";
import api from "../../helper/api";
import { getServerURL } from "../../helper/envConfig";
import { useTranslation } from "react-i18next";
import "../../i18n"; // important to import
function FamilyUserPlans() {
  const { t } = useTranslation("FamilyUserPlans");
  const navigate = useNavigate();
  const serverURL = getServerURL();
  const [user, setUser] = useState({});

  const trailsData = [
    {
      id: 1,
      title: t("trail_1_title"),
      description: t("trail_1_description"),
      imageSrc: "/png/trails-1.png",
    },
    {
      id: 2,
      title: t("trail_2_title"),
      description: t("trail_2_description"),
      imageSrc: "/png/trails-2.png",
    },
    {
      id: 3,
      title: t("trail_3_title"),
      description: t("trail_3_description"),
      imageSrc: "/png/trails-3.png",
    },
    {
      id: 4,
      title: t("trail_4_title"),
      description: t("trail_4_description"),
      imageSrc: "/png/trails-4.png",
    },
    {
      id: 5,
      title: t("trail_5_title"),
      description: t("trail_5_description"),
      imageSrc: "/png/trails-5.png",
    },
    {
      id: 6,
      title: t("trail_6_title"),
      description: t("trail_6_description"),
      imageSrc: "/png/trails-6.png",
    },
    {
      id: 7,
      title: t("trail_7_title"),
      description: t("trail_7_description"),
      imageSrc: "/png/trails-7.png",
    },
    {
      id: 8,
      title: t("trail_8_title"),
      description: t("trail_8_description"),
      imageSrc: "/png/trails-8.png",
    },
    {
      id: 9,
      title: t("trail_9_title"),
      description: t("trail_9_description"),
      imageSrc: "/png/trails-9.png",
    },
    {
      id: 10,
      title: t("trail_10_title"),
      description: t("trail_10_description"),
      imageSrc: "/png/trails-10.png",
    },
    {
      id: 11,
      title: t("trail_11_title"),
      description: t("trail_11_description"),
      imageSrc: "/png/trails-11.png",
    },
    {
      id: 12,
      title: t("trail_12_title"),
      description: t("trail_12_description"),
      imageSrc: "/png/trails-12.png",
    },
    {
      id: 13,
      title: t("trail_13_title"),
      description: t("trail_13_description"),
      imageSrc: "/png/trails-13.png",
    },
    {
      id: 14,
      title: t("trail_14_title"),
      description: t("trail_14_description"),
      imageSrc: "/png/trails-14.png",
    },
    {
      id: 15,
      title: t("trail_15_title"),
      description: t("trail_15_description"),
      imageSrc: "/png/trails-15.png",
    },
    {
      id: 16,
      title: t("trail_16_title"),
      description: t("trail_16_description"),
      imageSrc: "/png/trails-16.png",
    },

    // Add more items as needed
  ];

  const employeesPricing = [
    { min: 0, max: 50, price: 72 },
    { min: 51, max: 100, price: 69 },
    { min: 101, max: 500, price: 66 },
    { min: 501, max: 1000, price: 63 },
    { min: 1001, max: 2000, price: 60 },
    { min: 2001, max: 3000, price: 56 },
    { min: 3001, max: 5000, price: 52 },
    { min: 5001, max: Infinity, price: 48 },
  ];

  useEffect(() => {
    const decryptedInfoResult = decryptFromStoreLoc("user");
    setUser(decryptedInfoResult);
    localStorage.removeItem("state");
  }, []);

  const handleNavigate = async (data) => {
    try {
      if (data === "one") {
        const response = await api.postWithToken(
          `${serverURL}payments/is-free-plan-used/`,
          {}
        );
        if (response.data.is_free_plan_used) {
          toast.error(response.data.message);
          return;
        }
      }
    } catch (error) {
      console.log(error);
    }

    if (user?.role === 13) {
      if (data === "one") {
        navigate("/course-trails", {
          state: {
            name: "one",
            plan: "Tier One- One trail",
            userPlan: {
              employee: 0,
              perEmployeePrice: 0,
              subscriptionAmount: 0,
            },
          },
        });
      } else if (data === "two") {
        navigate("/course-trails", {
          state: {
            name: "two",
            plan: "Tier Two- Two Trails",
            userPlan: {
              employee: 0,
              perEmployeePrice: 12,
            },
          },
        });
      } else {
        navigate("/family-blended-learning", {
          state: {
            name: "three",
            plan: "Tier Three-Gold - All trails",
            userPlan: {
              employee: 0,
              perEmployeePrice: 72,
            },
            courseTrails: [],
          },
        });
      }
    }
  };

  return (
    <>
      <Header />
      <section className="payment-flow-section">
        <div className="container">
          <h3 className="welcome-title max-width-100">
            {t("chooseyoursubscriptionplan")}
          </h3>
          {user?.role === 13 && (
            <p className="welcome-description plan-description">
              {t("plan_selection")}
            </p>
          )}
          <div className="row plans-card g-4">
            <div className="col-md-6 col-lg-6 col-xl-4">
              <div className="card border-0 h-100">
                <div className="card-body p-0">
                  <h3> {t("tieroneonetrail")}</h3>
                  <p>
                    {t("single")}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip-top">
                          {t("trail_description")}
                        </Tooltip>
                      }
                    >
                      <span className="tooltip-hover px-1 fw-600">
                        {t("trail")}
                      </span>
                    </OverlayTrigger>
                    {t("basic_courses")}
                  </p>
                  <h2> {t("free")}</h2>
                </div>
                <div className="card-footer bg-transparent border-0 p-0 d-flex justify-content-center">
                  <button
                    className="w-auto text-decoration-none"
                    onClick={() => handleNavigate("one")}
                  >
                    {t("getstarted")}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-4">
              <div className="card border-0 h-100">
                <div className="card-body p-0">
                  <h3> {t("tiertwotwotrails")}</h3>
                  <p>
                    {t("several")}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="tooltip-top">
                          {t("trail_description1")}
                        </Tooltip>
                      }
                    >
                      <span className="tooltip-hover px-1 fw-600">
                        {t("trails")}
                      </span>
                    </OverlayTrigger>
                    {t("basic_courses1")}
                  </p>
                  {user?.role === 13 && <h2>€12</h2>}
                  <p className="employee mb-0 h-auto">{t("peryear")}</p>
                </div>
                <div className="card-footer bg-transparent border-0 p-0">
                  <div className="card-footer bg-transparent border-0 p-0 d-flex justify-content-center">
                    <button
                      className="w-auto text-decoration-none"
                      onClick={() => handleNavigate("two")}
                    >
                      {t("getstarted")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-4">
              <div className="card border-0 h-100">
                <div className="card-body p-0">
                  <h3 className="max-width-100">
                    {t("tierthreegoldalltrails")}
                  </h3>
                  <p>{t("course_description")}</p>
                  {user?.role === 13 && (
                    <>
                      <h2>€72</h2>
                      <p className="employee mb-0 h-auto">{t("peryear")}</p>
                    </>
                  )}
                </div>
                <div className="card-footer bg-transparent border-0 p-0">
                  <div className="d-flex justify-content-center">
                    <button
                      className="w-auto text-decoration-none"
                      onClick={() => handleNavigate("all")}
                    >
                      {t("getstarted")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="available-trails pb-md-5">
            <h3 className="welcome-title max-width-100">
              {t("availabletrails")}
            </h3>
            <p className="welcome-description plan-description">
              {t("subscription_trails")}
            </p>

            <Row className="available-trails-cards g-3">
              {trailsData.map((trail) => (
                <Col key={trail.id} md={6} lg={6} xl={4}>
                  <Card>
                    <Card.Body>
                      <div className="d-flex align-items-center gap-3">
                        <img
                          width={100}
                          height={100}
                          src={trail.imageSrc}
                          alt={trail.title}
                        />
                        <div>
                          <h5>{trail.title}</h5>
                          <p>{trail.description}</p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default FamilyUserPlans;
